import { TListResponse } from 'src/common/types';


export type TAccountProviderUserHealthCheck = {
  id: number;
	name: string;
	isActive: boolean;
	isSetCredential: boolean;
};

export type TAccountProviderUserHealthCheckResponse = {
  id: number;
	name: string;
	is_active: boolean;
	is_set_credential: boolean;
};

export type TAccountProviderUserHealthCheckListResponse = TListResponse<TAccountProviderUserHealthCheckResponse>;

export type TAccountProviderUserHealthCheckList = TListResponse<TAccountProviderUserHealthCheck>;

export function adaptAccountProviderUserHealthCheckFromListResponse(data: TAccountProviderUserHealthCheckListResponse): TAccountProviderUserHealthCheckList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptAccountProviderUserHealthCheckFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptAccountProviderUserHealthCheckFromResponse(data: TAccountProviderUserHealthCheckResponse): TAccountProviderUserHealthCheck {
	const {
		id,
		name,
		is_active: isActive,
		is_set_credential: isSetCredential,
	} = data;

	return {
		id,
		name,
		isActive,
		isSetCredential,
	};
}
